export const reasonsForNegativeScore = [
  "poor_active_listening",
  "repetitive_questions",
  "inconsistent_information",
  "language_barriers",
  "missed_to_ask_clarifying_question",
  "rushed_responses",
  "lack_of_empathy",
  "failure_to_acknowledge_mistake",
  "long_wait_times",
  "lack_of_confidence",
  "inability_to_address_urgency",
  "impersonal_interactions",
  "unresponsive",
  "not_getting_to_the_point",
  "lack_of_customer_education",
  "inadequate_follow_up",
  "inaccurate_promises",
  "missed_to_set_proper_expectations",
  "invalid_escalations",
  "no_thorough_investigation",
  "lack_of_product_knowledge_expertise",
  "faild_to_confirm_resolution",
  "unresolved_issues",
] as const;
export type ReasonForNegativeScore = (typeof reasonsForNegativeScore)[number];

export function isReasonForNegativeScore(
  reason: string
): reason is ReasonForNegativeScore {
  return reasonsForNegativeScore.includes(reason as ReasonForNegativeScore);
}

export const questionTypes = ["binary", "rating"] as const;
export type QuestionType = (typeof questionTypes)[number];

export const scoreEntities = ["ticket", "conversation", "agent"] as const;
export type ScoreEntity = (typeof scoreEntities)[number];

export type SampleFormInScore = {
  id: number;
  name: string;
  clientType: QuestionType;
};

export interface QaScore {
  id: number;
  title: string;
  content: string;
  autoScore: number;
  adjustedScore: number;
  autoScoreExplanation?: string;
  reasonForNegativeScore?: ReasonForNegativeScore;
  reasonsForNegativeScore: ReasonForNegativeScore[];
  comment?: string;
  type: QuestionType;
  scoreEntity: ScoreEntity;
  agentId?: number;
  brief?: string;
  sampleForm?: SampleFormInScore;
}

export const questionsOrder: Record<string, number> = {
  "UNDERSTAND THE INQUIRY": 4,
  "SHOW EMPATHY": 3,
  "EXPLAIN PLAN OF ACTION": 2,
  "RESOLUTION CONFIRMATION": 1,
};
